import hebermentapplicationDefaultImage from '../assets/smartwork-hebergement-applications.webp'
import hebergementecommerceDefaultImage from '../assets/smartwork-hebergement-vitrine-e-commerce.webp'
import hebergementopensourceDefaultImage from '../assets/smartwork-hebergement-open-source.webp'
import hebergementsurmesureDefaultImage from '../assets/smartwork-hebergement-sur-mesure.webp'

const hebergementecommerceImage = import.meta.env.VITE_HEBERGEMENT_ECOMMERCE_IMAGE || hebergementecommerceDefaultImage
const hebergementecommerceImageAlt = import.meta.env.VITE_HEBERGEMENT_ECOMMERCE_ALT || 'SmartWork des assistants IA pour rédiger, analyser et répondre plus vite, en toute confidentialité.'

const hebermentapplicationImage = import.meta.env.VITE_HEBERGEMENT_APPLICATION_IMAGE || hebermentapplicationDefaultImage
const hebermentapplicationImageAlt = import.meta.env.VITE_HEBERGEMENT_APPLICATION_ALT || 'SmartWork des environnements IA dédiés aux métiers et aux processus de votre entreprise.'

const hebergementopensourceImage = import.meta.env.VITE_HEBERGEMENT_OPEN_SOURCE_IMAGE || hebergementopensourceDefaultImage
const hebergementopensourceImageAlt = import.meta.env.VITE_HEBERGEMENT_OPEN_SOURCE_ALT || 'SmartWork une IA souveraine fondée sur des technologies Open Source maîtrisées.'

const hebergementsurmesureImage = import.meta.env.VITE_HEBERGEMENT_SURMESURE_IMAGE || hebergementsurmesureDefaultImage
const hebergementsurmesureImageAlt = import.meta.env.VITE_HEBERGEMENT_SURMESURE_ALT || 'SmartWork des assistants IA sur mesure, construits avec vos équipes pour vos enjeux.'

export const services = [
  {
    key: 'services-tpe-pme',
    title: 'TPE & PME',
    subtitle: 'tous les métiers',
    text: 'Rédaction, email, synthèse, support client : une IA souveraine prête à l’emploi pour gagner du temps dès le premier jour.',
    icon: 'vitrine-e-commerce',
    image: hebergementecommerceImage,
    imageAlt: hebergementecommerceImageAlt,
  },
  {
    key: 'services-metiers',
    title: 'Entreprises & administrations',
    subtitle: 'usages avancés & conformité',
    text: 'Cloisonnement des données, rôles RGPD, assistants métier : innover sans exposer vos informations sensibles.',
    icon: 'applications',
    image: hebermentapplicationImage,
    imageAlt: hebermentapplicationImageAlt,
  },
  {
    key: 'services-integrateurs',
    title: 'Cabinets, agences & IT',
    subtitle: 'multi-clients',
    text: 'Déployez une IA souveraine pour vous et vos clients, avec des comptes séparés et une facturation claire.',
    icon: 'open-source',
    image: hebergementopensourceImage,
    imageAlt: hebergementopensourceImageAlt,
  },
  {
    key: 'services-sur-mesure',
    title: 'Projets sur mesure',
    subtitle: 'cas d’usage dédiés',
    text: 'Assistants spécialisés, connecteurs, automatisations : nous construisons avec vous l’IA dont vous avez besoin.',
    icon: 'sur-mesure',
    image: hebergementsurmesureImage,
    imageAlt: hebergementsurmesureImageAlt,
  },
]
